// src/pages/ArchiveMonthsByCategory.tsx
import React from 'react';

import { useParams, useNavigate, Link } from 'react-router-dom';
import { useCanonicalTag } from 'src/components/seo/useCanonicalTag';
import { useTranslations } from 'src/contexts/TranslationContext';
import { formatCategoryName } from 'src/utils/categoryFormatter';
import {PageTitleDescriptionHelmet} from 'src/components/seo/NewsPageHelmets';

const generateYearMonths = (startYear: number, startMonth: number): string[] => {
  const result: string[] = [];

  // Current year and month
  const now = new Date();
  const endYear = now.getFullYear();
  const endMonth = now.getMonth() + 1; // getMonth() is zero-based

  let y = startYear;
  let m = startMonth;

  while (y < endYear || (y === endYear && m <= endMonth)) {
    const mm = m < 10 ? '0' + m : m.toString();
    result.push(`${y}${mm}`);
    m++;
    if (m > 12) {
      m = 1;
      y++;
    }
  }

  return result;
};



const ArchiveMonthsByCategory: React.FC = () => {
  const { category } = useParams();
  const navigate = useNavigate();
  const { language, getUrlLanguagePrefix, translations: t } = useTranslations();

  if (!category) return <div>Invalid category</div>;

  const yearMonths = generateYearMonths(2025, 4);

  const handleMonthClick = (yyyymm: string) => {
    const prefix = getUrlLanguagePrefix(language);
    navigate(`${prefix}/news/archive/category/${category}/${yyyymm}`);
  };

  const formatMonthLabel = (yyyymm: string) => {
    const year = parseInt(yyyymm.slice(0, 4));
    const month = parseInt(yyyymm.slice(4, 6));
    return new Date(year, month - 1).toLocaleString(language || 'en', {
      year: 'numeric',
      month: 'long',
    });
  };

  // adds or updates <link rel="canonical">
  useCanonicalTag();

  return (
    <div className="max-w-5xl mx-auto p-6">

   

      <PageTitleDescriptionHelmet
        title={`${t?.navigations?.archive?.title || 'News Archive'}  ${t?.navigations?.header?.[category] || category} {"by month"}`}
        description={`Explore archived news in language ${language} for ${formatCategoryName(category)} from ${yearMonths
            .map((ym) => formatMonthLabel(ym))
            .join(', ')}`}
      />


      <h1 className="text-3xl font-bold mb-6 text-center">
        {t?.navigations?.archive?.title || 'News Archive'} —{' '}
        {t?.navigations?.header?.[category] || formatCategoryName(category)}


      </h1>

      {/* <p className="mb-4 text-center text-gray-700">
        {t?.archive?.selectMonth || 'Select a month to view news'}
      </p> */}
      <div className="max-w-3xl mx-auto">

        <div className="mb-6 text-left">
          <Link to={`${getUrlLanguagePrefix(language)}/news/archive/`} className="text-blue-600 hover:underline text-lg sm:text-xl font-semibold">
            ← {t?.archive?.backToArchive || 'Back to Archive'}
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
          {yearMonths.map((yyyymm) => (
            <button
              key={yyyymm}
              onClick={() => handleMonthClick(yyyymm)}
              className="py-2 px-3 border rounded-md text-center hover:bg-blue-50 hover:border-blue-300 transition text-sm"
            >
              {formatMonthLabel(yyyymm)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArchiveMonthsByCategory;
